const line = {
  LINE: 'LINE',
  LINES: 'LINES',
};
export { line };
